import { render, staticRenderFns } from "./PhBbMapLayer.vue?vue&type=template&id=8cbf45a8&scoped=true&lang=html&"
import script from "./PhBbMapLayer.vue?vue&type=script&lang=js&"
export * from "./PhBbMapLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbf45a8",
  null
  
)

export default component.exports